<template>
  <EditForm :question="question" :editing="true"/>
</template>

<script>
import EditForm from '@/pages/admin/questions/test/EditForm'
import TestQuestionService from '@/services/TestQuestionService'

export default {
  props: {
    id: String
  },
  data: () => ({
    question: TestQuestionService.getDefaultItem(),
    testQuestionService: undefined
  }),
  components: {EditForm},
  created () {
    this.testQuestionService = new TestQuestionService(this.$store)
    this.testQuestionService.getItem(this.id, (data) => {
      this.question = data.question
      this.question.answers.sort(this.compareId)
    })
  },
  methods: {
    compareId (questionA, questionB) {
      return questionA.id - questionB.id
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/questions/test/Edit.vue